module.exports = __webpack_public_path__ + "img/数据.4e5e16cb.svg";